module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/setting/customers/customers-show/customers-show.component.scss
// module id = ./src/app/views/setting/customers/customers-show/customers-show.component.scss
// module chunks = main